import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-modal-bootstrap";
import flattenAmountBifurcation from "@utils/flattenAmountBifurcation";
import { getDoctorDisplayName, formatDateLabel, formatTime } from "@utils/docConsultUtils";
import HEART_ICON from "@images/heart.svg";
import { BIFURCATION_TYPE_TOTAL_PAYABLE } from "../../constants";
import "./style.scss";

const staticText = {
  orderPlaced: 'Order Placed - ',
  bookingSuccess: 'Booking Scheduled Success',
  patientNameLabel: 'Patient name: ',
  orderIdLabel: 'Order ID: ',
  doctorBooked: 'Doctor Booked:',
  appointmentDate: 'Appointment Date:',
  appointmentTime: 'Appointment Time:',
  serveNext: 'SERVE NEXT ORDER',
  successAlt: 'success',
  yearsExp: 'years Exp',
};

const DocConsultSuccessModal = ({
  orderId,
  patientName,
  doctor,
  slot,
  date,
  bifurcationData,
  consultationFees,
  onServeNext,
  doctorLabel,
}) => {
  const displayName = getDoctorDisplayName(doctor);

  const invoice = flattenAmountBifurcation((bifurcationData && bifurcationData.amountBifurcation) || []);
  const totalItem = invoice.find(bifurcationItem => Number(bifurcationItem.type) === BIFURCATION_TYPE_TOTAL_PAYABLE) || invoice[invoice.length - 1];
  const totalDisplay = (totalItem && (totalItem.displayValue || totalItem.finalValue)) ||
    (consultationFees ? `₹${consultationFees}` : '—');

  const dateLabel = formatDateLabel(date);
  const startTime = slot ? formatTime(slot.start, { lowercase: true, unpaddedHours: true }) : "";
  const endTime = slot && slot.end ? formatTime(slot.end, { lowercase: true, unpaddedHours: true }) : "";
  const timeLabel = endTime ? `${startTime} to ${endTime}` : startTime;

  return (
    <Modal isOpen className="dcSuccessModal">
      <div className="dcSuccessBody">
        <img
          src={HEART_ICON}
          alt={staticText.successAlt}
          className="dcSuccessIcon"
        />

        <p className="dcSuccessTitle">
          <span className="dcSuccessTitleOrange">{staticText.orderPlaced}</span>
          <strong>{staticText.bookingSuccess}</strong>
        </p>

        <div className="dcSuccessCard">
          <div className="dcSuccessCardTop">
            <div className="dcSuccessPatientRow">
              <span className="dcSuccessPatientName">
                {staticText.patientNameLabel}{patientName}
              </span>
              <span className="dcSuccessOrderId">{staticText.orderIdLabel}{orderId}</span>
            </div>
            <span className="dcSuccessAmount">{totalDisplay}</span>
          </div>

          <div className="dcSuccessDetail">
            <div className="dcDoctorNameContainer">
              <strong>{doctorLabel || staticText.doctorBooked}</strong>
              <div className="dcDoctorName">
                {displayName}{" "}
                {(doctor.specialization || doctor.yearsOfExperience) && (
                  <span className="dcSuccessDetailSub">
                    {[
                      doctor.specialization,
                      doctor.yearsOfExperience &&
                        `${doctor.yearsOfExperience} ${staticText.yearsExp}`,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </span>
                )}
              </div>
            </div>
            {dateLabel && (
              <p>
                <strong>{staticText.appointmentDate}</strong> {dateLabel}
              </p>
            )}
            {timeLabel && (
              <p>
                <strong>{staticText.appointmentTime}</strong> {timeLabel}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="dcSuccessFooter">
        <div className="dcServeNext" onClick={onServeNext}>
          {staticText.serveNext}
        </div>
      </div>
    </Modal>
  );
};

DocConsultSuccessModal.propTypes = {
  orderId: PropTypes.string.isRequired,
  patientName: PropTypes.string.isRequired,
  doctor: PropTypes.object.isRequired,
  slot: PropTypes.object,
  date: PropTypes.string,
  bifurcationData: PropTypes.object,
  consultationFees: PropTypes.number,
  doctorLabel: PropTypes.string,
  onServeNext: PropTypes.func.isRequired,
};

export default DocConsultSuccessModal;
